export default "__VITE_ASSET__DeLQtUrD__"